export default __webpack_public_path__ + "static/media/mobile_logo.17095edb.svg";